import(/* webpackMode: "eager", webpackExports: ["WidgetCatalog"] */ "/vercel/path0/src/components/widgetCatalog/widgetCatalog.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetsHero"] */ "/vercel/path0/src/components/widgetsHero/widgetsHero.comp.tsx");
